import React from 'react';
import Head from 'next/head';
import Link from 'next/link';
import { useTranslation } from '@/hooks/useTranslation';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { GetServerSideProps, GetServerSidePropsContext } from 'next';
import { LoginFormDirect } from '@/components/auth/LoginFormDirect';
import { AuthShell } from '@/components/auth/AuthShell';
import Layout from '@/components/Layout';

export default function SignInPage() {
  const { t } = useTranslation();

  return (
    <>
      <Head>
        <title>{t('auth.signIn.metaTitle')}</title>
        <meta name="description" content={t('auth.signIn.metaDescription')} />
      </Head>

      <Layout>
        <AuthShell
          title={t('auth.signIn.heading')}
          footer={
            <>
              {t('auth.signIn.or')}{' '}
              <Link href="/auth/signup" className="link">
                {t('auth.signIn.createNewAccount')}
              </Link>
            </>
          }
        >
          <LoginFormDirect />
        </AuthShell>
      </Layout>
    </>
  );
}

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  return {
    props: {
      ...(await serverSideTranslations(context.locale ?? 'en', ['common'])),
    },
  };
};
